import { parseThirdPartyResponsible } from '@risksmart-app/shared/src/forms/issue-assessments/thirdPartyResponsibleCodec';

export const formatIssueThirdPartyResponsible = (
  typedNames: string | null | undefined,
  registeredNames: (string | null | undefined)[]
): string => {
  const names = [...parseThirdPartyResponsible(typedNames), ...registeredNames]
    .map((name) => name?.trim())
    .filter((name): name is string => Boolean(name));

  return [...new Set(names)].sort((a, b) => a.localeCompare(b)).join(', ');
};
